import React, { memo, useMemo } from "react";
import { Grid } from "@mui/material";
import { useField } from "formik";

import RRDDirectStoreCopyToggleInput from "../common/rrdInputFields/RRDDirectStoreCopyToggleInput";
import RRDDirectStoreQntInput from "../common/rrdInputFields/RRDDirectStoreQntInput";
import RRDDirectStoreCopyCostInput from "../common/rrdInputFields/RRDDirectStoreCopyCostInput";
import { resolveRRDStoreCopyConfig } from "../../utils/rrdStoreCopyConfigHelper";

type RRDLocationStoreCopyProps = {
  locationId: string | number;
  distributionToggleName: string;
  storeCopyCPMAdmin?: number;
  address?: string;
  onOpenFeedback?: () => void;
};

function RRDLocationStoreCopy({
  locationId,
  distributionToggleName,
  storeCopyCPMAdmin,
  address,
  onOpenFeedback,
}: RRDLocationStoreCopyProps) {
  const [{ value: isDistributionOn }] = useField(distributionToggleName);
  const [{ value: locationValue = {} }] = useField(locationId as any);
  const storeCopyConfig = useMemo(
    () =>
      resolveRRDStoreCopyConfig({
        location: locationValue,
      }),
    [locationValue]
  );

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12, md: 4 }}>
        <RRDDirectStoreCopyToggleInput
          name={`${locationId}.store_copy`}
          disabled={!isDistributionOn}
          address={address}
          onOpenFeedback={onOpenFeedback}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <RRDDirectStoreQntInput
          name={`${locationId}.store_copy_qnt`}
          storeCopyToggleName={`${locationId}.store_copy`}
          storeCopyConfig={storeCopyConfig}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 4 }}>
        <RRDDirectStoreCopyCostInput
          name={`${locationId}.store_copy_cost`}
          storeCopyToggleName={`${locationId}.store_copy`}
          storeCopyQntName={`${locationId}.store_copy_qnt`}
          storeCopyCPMAdmin={storeCopyCPMAdmin}
          storeCopyConfig={storeCopyConfig}
        />
      </Grid>
    </Grid>
  );
}

export default memo(RRDLocationStoreCopy);
